export default "__VITE_PUBLIC_ASSET__5fb20b51__"